import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const gainedLostFollowersHistoryConfig = {
    title: 'chart.tiktok.gained_lost_followers_history',
    tooltip: 'chart.tiktok.tooltip_gained_lost_followers_history',
    id: 'gained_lost_followers_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        gained: 'chart.tiktok.gained_lost_followers_history_gained',
        lost: 'chart.tiktok.gained_lost_followers_history_lost',
        total: 'chart.tiktok.gained_lost_followers_history_total',
        posts: 'chart.tiktok.gained_lost_followers_history_posts'
    },
    social: TIKTOK_BUSINESS,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'chart.post_engagements.followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        gained: 'green',
        lost: 'gray',
        posts: 'blue'
    },
    legendTypes: {
        gained: 'square',
        lost: 'square',
        posts: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart,
    new: {
        dateAdded: '2025-08-06'
    }
};
